module.exports = __webpack_public_path__ + "img/logo3.91216d95.png";